import RegistrationTimesDataStoreFactory from '../factories/RegistrationTimesDataStoreFactory';
import RegistrationTimesStore from '../datastores/RegistrationTimesStore';
import RegistrationTimesRepository from '@/domain/repositories/RegistrationTimesRepository';

export default class RegistrationTimesDataRepository
  implements RegistrationTimesRepository
{
  getRegistrationTimes(
    courseId: string,
    campus: string,
    career: string,
    plan: string,
    prog: string,
    period: string
  ) {
    const registrationTimesDataStore: RegistrationTimesStore =
      RegistrationTimesDataStoreFactory.create();
    return registrationTimesDataStore.getRegistrationTimes(
      courseId,
      campus,
      career,
      plan,
      prog,
      period
    );
  }
}
